/**
 * Shared field-label mapping used by ExtractionResultCard and
 * ValidationChecksCard. Both components render side-by-side in the Invoice
 * Review modal, so the labels must stay in sync — keep this as the single
 * source of truth.
 */
export const FIELD_LABELS: Record<string, string> = {
  invoice_number: "Invoice Number",
  invoice_date: "Invoice Date",
  po_number: "PO Number",
  po_date: "PO Date",
  invoice_total_value: "Invoice Value",
  bill_to_entity: "Billing Entity",
  bill_to_address: "Bill to Address",
  bill_to_gstin: "Bill to GSTIN",
  ship_to_entity: "Ship to Entity",
  ship_to_address: "Ship to Address",
  ship_to_gstin: "Ship to GSTIN",
  seller_entity: "Seller Entity",
  seller_gstin: "Seller GSTIN",
  seller_address: "Seller Address",
  hsn_code: "HSN / SAC Code",

  // Edit form field aliases (invoice record field names)
  invoice_no: "Invoice Number",
  invoice_value: "Invoice Value",
  billing_entity: "Billing Entity",
  hsn_sac_codes: "HSN / SAC Codes",
  additional_charges: "Additional Charges",
  bill_to_name: "Billing Entity",
};

export function getFieldLabel(field: string): string {
  return (
    FIELD_LABELS[field] ??
    field.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
  );
}
